// FORM PRODUCT PAGE

window.addEventListener('load', function() {
    // let formText = document.querySelectorAll('.mw-option');
    let formText = document.querySelectorAll('.mw-option--type-select');
    const waitForFormText = setInterval(() => {
      formText = document.querySelectorAll('.mw-option--type-select');
      if (formText.length > 0) {
        clearInterval(waitForFormText);
        formText.forEach(element => {
          const formLabel = element.querySelector('.mw-text');
          const formSelect = element.querySelector('.selectCustom-option--default');
          const formSelectLabel = element.querySelector('.selectCustom-trigger');
          const mwOptionControl = element.querySelector('.selectCustom');
          formSelect.innerText = `${formLabel.innerText}`;
          formSelectLabel.innerText = `${formLabel.innerText}`;
          mwOptionControl.style.display = 'block';
          const mwStackItem = document.querySelectorAll('.mw-stack__item--fill');
          mwStackItem.forEach(item => {
            const arrow = `<div class="select-arrow">
              <svg class="select-arrow_svg" role="presentation" viewBox="0 0 19 12">
                <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
              </svg>
            </div>`;
            item.insertAdjacentHTML('afterbegin', arrow);
          });
        });
      }
    }, 100);
  });

// hide skeleton on product page

window.onload = () => {
    if (document.body.classList.contains('template-product')) {
      document.querySelector('.skeleton_wr').style.setProperty('display', 'none', 'important');
      document.querySelector('.mw_style').remove()
    }
}

const linkUnderlinePink = document.querySelectorAll(".link_underline_pink ");
for (let item of linkUnderlinePink){
  if(item.innerHTML.replace(/ /g,'').toLowerCase() == "shopall"){
    item.style.borderTop = '1px solid #dfdfdfa1';
    item.style.width = '100%';
    item.style.paddingTop = '10px';
    item.classList.add("link_not_underline");
  }
};  